module.exports = __webpack_public_path__ + "static/media/phone-rotary.5dd99ccc.svg";